import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _Icon;
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useElementDimensions } from '../../utils';
import { useConvertToMobile } from '../../utils/useConvertToMobile';
import { Icon } from '../../Icon';
import { Button } from '../../Button/Button';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function FloatingAlert(props) {
  var _props$body = props.body,
    body = _props$body === void 0 ? '' : _props$body,
    _props$header = props.header,
    header = _props$header === void 0 ? '' : _props$header,
    _props$hidePrimaryBut = props.hidePrimaryButton,
    hidePrimaryButton = _props$hidePrimaryBut === void 0 ? false : _props$hidePrimaryBut,
    _props$hideSecondaryB = props.hideSecondaryButton,
    hideSecondaryButton = _props$hideSecondaryB === void 0 ? false : _props$hideSecondaryB,
    _props$hideXCloseButt = props.hideXCloseButton,
    hideXCloseButton = _props$hideXCloseButt === void 0 ? false : _props$hideXCloseButt,
    _props$icon = props.icon,
    icon = _props$icon === void 0 ? 'InfoCircle' : _props$icon,
    mobileBreakpoint = props.mobileBreakpoint,
    mobileBreakpointContainerRef = props.mobileBreakpointContainerRef,
    onClose = props.onClose,
    onPrimaryButtonClick = props.onPrimaryButtonClick,
    onSecondaryButtonClick = props.onSecondaryButtonClick,
    primaryButtonContent = props.primaryButtonContent,
    primaryButtonEndIcon = props.primaryButtonEndIcon,
    primaryButtonProps = props.primaryButtonProps,
    primaryButtonStartIcon = props.primaryButtonStartIcon,
    secondaryButtonContent = props.secondaryButtonContent,
    secondaryButtonEndIcon = props.secondaryButtonEndIcon,
    secondaryButtonProps = props.secondaryButtonProps,
    secondaryButtonStartIcon = props.secondaryButtonStartIcon,
    _props$stackButtonsIn = props.stackButtonsInMobileView,
    stackButtonsInMobileView = _props$stackButtonsIn === void 0 ? false : _props$stackButtonsIn;
  var isMobile = useConvertToMobile(mobileBreakpoint, mobileBreakpointContainerRef);
  var closeButton = useMemo(function () {
    return /*#__PURE__*/_jsx(Button, {
      onClick: onClose,
      sx: {
        ml: !isMobile && !body ? 3 : 0
      },
      variant: "link-gray",
      children: _Icon || (_Icon = /*#__PURE__*/_jsx(Icon, {
        iconId: "XClose"
      }))
    });
  }, [body, isMobile, onClose]);
  var innerContainerRef = useRef(null);
  var _useElementDimensions = useElementDimensions(innerContainerRef),
    innerContainerWidth = _useElementDimensions.width;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    maxInnerContainerWidth = _useState2[0],
    setMaxInnerContainerWidth = _useState2[1];
  useEffect(function () {
    if (!maxInnerContainerWidth) {
      setMaxInnerContainerWidth(innerContainerWidth);
    }
  }, [innerContainerWidth, maxInnerContainerWidth]);
  var actionButtons = useMemo(function () {
    return /*#__PURE__*/_jsxs(Stack, {
      alignItems: "center",
      direction: stackButtonsInMobileView && isMobile ? 'column-reverse' : 'row',
      spacing: 3,
      sx: {
        alignItems: 'center',
        mt: "0px !important"
      },
      children: [!hideSecondaryButton && /*#__PURE__*/_jsx(Button, _extends({
        endIcon: secondaryButtonEndIcon,
        fullWidth: isMobile && stackButtonsInMobileView,
        onClick: onSecondaryButtonClick,
        size: "small",
        startIcon: secondaryButtonStartIcon,
        variant: "link-gray"
      }, secondaryButtonProps, {
        children: secondaryButtonContent
      })), !hidePrimaryButton && /*#__PURE__*/_jsx(Button, _extends({
        endIcon: primaryButtonEndIcon,
        fullWidth: isMobile && stackButtonsInMobileView,
        onClick: onPrimaryButtonClick,
        size: "small",
        startIcon: primaryButtonStartIcon,
        variant: "secondary-gray"
      }, primaryButtonProps, {
        children: primaryButtonContent
      }))]
    });
  }, [hidePrimaryButton, hideSecondaryButton, isMobile, onPrimaryButtonClick, onSecondaryButtonClick, primaryButtonContent, primaryButtonEndIcon, primaryButtonStartIcon, secondaryButtonContent, primaryButtonProps, secondaryButtonProps, secondaryButtonEndIcon, secondaryButtonStartIcon, stackButtonsInMobileView]);
  return /*#__PURE__*/_jsxs(Stack, {
    alignItems: "center",
    direction: isMobile ? 'column' : 'row',
    justifyContent: "space-between",
    sx: {
      overflowX: 'hidden',
      width: '100%'
    },
    "data-element": "Stack",
    "data-component": "FloatingAlert",
    "data-source-file": "FloatingAlert.tsx",
    children: [/*#__PURE__*/_jsxs(Stack, {
      direction: "row",
      justifyContent: isMobile ? 'space-between' : 'center',
      sx: {
        mb: isMobile ? 4 : "".concat(body ? 'auto' : '0px')
      },
      width: isMobile ? '100%' : 'fit-content',
      "data-element": "Stack",
      "data-source-file": "FloatingAlert.tsx",
      children: [/*#__PURE__*/_jsx(Icon, {
        iconId: icon,
        sx: {
          mr: 4
        },
        "data-element": "Icon",
        "data-source-file": "FloatingAlert.tsx"
      }), isMobile && /*#__PURE__*/_jsx(Box, {
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        children: !hideXCloseButton && closeButton
      })]
    }), /*#__PURE__*/_jsxs(Stack, {
      alignItems: isMobile ? 'unset' : 'center',
      flexDirection: isMobile ? 'column' : 'row',
      gap: "12px",
      justifyContent: "space-between",
      marginRight: isMobile ? '0px' : '12px',
      spacing: '4px',
      width: "100%",
      "data-element": "Stack",
      "data-source-file": "FloatingAlert.tsx",
      children: [/*#__PURE__*/_jsxs(Stack, {
        "data-element": "Stack",
        "data-source-file": "FloatingAlert.tsx",
        children: [header && /*#__PURE__*/_jsx(Typography, {
          color: "inherit",
          variant: "text-sm-semibold",
          children: header
        }), body && /*#__PURE__*/_jsx(Typography, {
          color: "inherit",
          variant: "text-sm-regular",
          children: body
        })]
      }), !(hideSecondaryButton && hidePrimaryButton) && actionButtons]
    }), !isMobile && !body && !hideXCloseButton && closeButton, !isMobile && body && /*#__PURE__*/_jsx(Box, {
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      padding: 2,
      children: !hideXCloseButton && closeButton
    })]
  });
}